// Login.jsx
import React, { useRef, useState } from "react";
import { CustomInput } from "../components/Input/input";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import axios from "axios";
import { API_BASE_URL } from "../utils/constants";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
  const toast = useRef(null);
  const navigate = useNavigate();
  const [data, setData] = useState({ username: "", password: "" });

  const handleSubmit = async (e) => {
    if (data.username === "" || data?.password === "") {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Username and Password required",
      });
    } else {
      try {
        const response = await axios.post(
          API_BASE_URL + "/api/user/login",
          data
        );
        const token = response.data.data.token;
        sessionStorage.setItem("token", token);
        navigate('/shah-admin/')
      } catch (err) {
        console.log("err", err);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: err?.response?.data?.message,
        });
      }
    }
  };

  return (
    <div className="flex align-items-center p-3 justify-content-center">
      <Toast ref={toast} />
      <div className="my-5 border-1 w-12 md:w-6 shadow-3 border-gray-300 border-round-xl p-3">
        <h2 className="text-center">Admin Login</h2>
        <CustomInput
          name="username"
          col={12}
          label="Username"
          onChange={({ name, value }) =>
            setData((prev) => ({ ...prev, [name]: value }))
          }
        />
        <CustomInput
          name="password"
          type="password"
          col={12}
          label="Password"
          onChange={({ name, value }) =>
            setData((prev) => ({ ...prev, [name]: value }))
          }
        />
        <div className="p-2 flex justify-content-center">
          <Button label="Login" className="w-6" onClick={handleSubmit} />
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
